import { fancyConfirm } from "components/ui/fancy-confirm";

export const sendEmptySubjectConfirmation = async (): Promise<boolean> => {
    return await fancyConfirm(
        "Send with empty subject?",
        "This message contains no subject; would you like to send anyways?",
        "Send anyways",
        "Edit message",
    );
};

export const discardEmailConfirmation = async (): Promise<boolean> => {
    return await fancyConfirm(
        "Discard message?",
        "Are you sure you would like to close and discard this message?",
        "Close",
        "Keep open",
    );
};

export const cancelSendConfirmation = async (): Promise<boolean> => {
    return await fancyConfirm(
        "Stop sending?",
        "We'll stop before sending the rest. Emails already sent can't be recalled.",
        "Stop sending",
        "Keep sending",
    );
};

export const closeWhileSendingConfirmation = async (): Promise<boolean> => {
    return await fancyConfirm(
        "Still sending",
        "This email is still being sent and will finish in the background. Close this window anyway?",
        "Close",
        "Keep open",
    );
};
